import {
  OutlinedInputProps,
  styled,
  TextField,
  TextFieldProps,
} from '@mui/material';
import {useFieldFocusStyle} from '../../../hooks/utils/useFieldFocusStyle';
import {useEffect, useRef} from 'react';
/*
Component for textfield
*/

type AurTextFieldProps = TextFieldProps & {
  ariaLabel?: string;
};

export const AurTextField = styled(
  ({className, ariaLabel, ...rest}: AurTextFieldProps) => {
    const {borderClass, focusHandler, mouseKeyDownHandler} = useFieldFocusStyle(
      {
        tabFocusClass: 'tabFocusedBorder',
        mouseFocusClass: 'mouseFocusedBorder',
      }
    );

    className = `${className} ${borderClass}`;

    // Merge the focus delegates
    const onFocus = (e: any) => {
      focusHandler && focusHandler(e);
      rest.onFocus && rest.onFocus(e);
    };

    // Merge the mouse down delegates
    const onMouseDown = (e: any) => {
      mouseKeyDownHandler && mouseKeyDownHandler(e);
      rest.onMouseDown && rest.onMouseDown(e);
    };

    const fieldRef = useRef<HTMLDivElement | null>(null);

    const focusDisableField = () => {
      if (fieldRef.current) {
        const child = fieldRef.current.querySelector(
          '.MuiFilledInput-root'
        ) as HTMLDivElement;
        const isDisabled = child?.classList.contains('Mui-disabled');
        if (isDisabled) {
          child.tabIndex = 0;
          child.classList.add('disableFocused');
        } else {
          child?.removeAttribute('tabindex');
          child?.classList.remove('disableFocused');
        }
      }
    };

    useEffect(() => {
      focusDisableField();
    }, []);

    focusDisableField();

    return (
      <TextField
        InputProps={{disableUnderline: true} as Partial<OutlinedInputProps>}
        className={className}
        {...rest}
        ref={fieldRef}
        onFocus={onFocus}
        onMouseDown={onMouseDown}
        inputProps={{
          ...rest.inputProps,
          'aria-label': ariaLabel,
        }}
      />
    );
  }
)(({theme}) => ({
  '& .MuiFilledInput-root': {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    '&:hover': {backgroundColor: theme.palette.action.hover},
    '&.Mui-focused': {backgroundColor: theme.palette.background.default},
  },
  '& .MuiInputLabel-root': {color: theme.palette.text.primary},
  '& .MuiInputBase-input': {color: theme.palette.text.primary},
  '& .MuiFormHelperText-root': {color: '#8596B0'},
  '& .MuiFormHelperText-root.Mui-error': {
    // error color from figma design
    color: '#ff7a7a', // Helper text color when error is true
  },

  // Added for match the figma design validable text field
  '& .MuiInputLabel-root.MuiInputLabel-shrink.Mui-error': {
    // error color from figma design
    color: '#ff7a7a', // Helper text color when error is true
  },
  // Added for match the figma design validable text field
  '& .MuiInputLabel-root.Mui-error': {
    // error color from figma design
    color: '#ff7a7a', // Helper text color when error is true
  },
}));
